import axios from 'axios';
import { storeSessionReady } from '../auth/api-auth';
import { SHOPIFY_APP_PROXY_LOGIN_URL } from '../api';

function getLoyaltyPointsSource() {
  return window.themeSettings?.loyaltyPointsSource || 'open_loyalty';
}

function buildGetMemberEndpoint(identifier) {
  const pointsSource = encodeURIComponent(getLoyaltyPointsSource());
  return `getMember?identifier=${encodeURIComponent(identifier)}&pointsSource=${pointsSource}`;
}

Shopify.functions.getMember = async function getMember() {
  const customerEmail = window.customer?.email;
  if (!customerEmail) return;

  console.log("Getting member...");

  // The proxy 401s without the session cookie that /store-login sets
  await storeSessionReady;

  const url = `${SHOPIFY_APP_PROXY_LOGIN_URL}/fetch-third-party-data`;

  try {
    const response = await axios.post(
      url,
      {
        endpoint: buildGetMemberEndpoint(customerEmail),
        method: "GET",
      },
      {
        withCredentials: true,
      }
    );

    const member = response.data;
    if (!member) {
      sessionStorage.removeItem("member");
      return;
    }

    sessionStorage.setItem("member", JSON.stringify(member));
    const event = new CustomEvent("member-updated");
    document.dispatchEvent(event);
    return member;
  } catch (error) {
    console.error("Failed to fetch member data:", error);
  }
};

Shopify.functions.getMemberFromStorage = function getMemberFromStorage() {
  const member = sessionStorage.getItem("member");
  if (!member) return;

  try {
    return JSON.parse(member);
  } catch (error) {
    console.error("Failed to parse stored member data:", error);
  }
}


Shopify.functions.showMemberSections = function showMemberSections(member, element) {
  if (!element) element = document;
  const loyaltyElements = element.querySelectorAll('[data-loyalty-member]');

  loyaltyElements.forEach((element) => {
    const value = element.dataset.loyaltyMember;
    if ((value === 'true' && member) || (value === 'false' && !member)) {
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  });
}

Shopify.functions.getTransactions = async function getTransactions() {
  const customerEmail = window.customer?.email;
  if (!customerEmail) return;

  console.log("Getting transactions...");

  await storeSessionReady;

  const url = `${SHOPIFY_APP_PROXY_LOGIN_URL}/fetch-third-party-data`;

  try {
    const response = await axios.post(
      url,
      {
        endpoint: `getTransaction?identifierKey=email&identifierValue=${encodeURIComponent(customerEmail)}&pointsSource=${encodeURIComponent(getLoyaltyPointsSource())}`,
        method: "GET",
      },
      {
        withCredentials: true,
      }
    )

    const transactions = response.data;
    if (!transactions) return;
    return transactions;
  } catch (error) {
    console.error("Failed to fetch transaction data:", error);
  }
}

Shopify.functions.getMemberByEmail = async function getMemberByEmail(email) {
  if (!email) return;

  await storeSessionReady;

  const url = `${SHOPIFY_APP_PROXY_LOGIN_URL}/fetch-third-party-data`;
  try {
    const response = await axios.post(
      url,
      {
        endpoint: buildGetMemberEndpoint(email),
        method: "GET",
      },
      {
        withCredentials: true,
      }
    );

    const member = response.data;
    if (!member) return;
    return member;
  } catch (error) {
    console.error("Failed to fetch member data:", error);
  }
}


// Execute

Shopify.functions.getMember();